import React from 'react';

type ClickHandler = (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => void;

export const createClickHandler = (
  onSingleClick: ClickHandler,
  onDoubleClick: ClickHandler,
  singleClickDelay = 500,
) => {
  let clickTimeout: any | null = null;

  const onClick: ClickHandler = (e) => {
    e.stopPropagation();

    if (clickTimeout !== null) {
      // 已存在定时器，说明这是第二次点击，判定为双击
      clearTimeout(clickTimeout);
      clickTimeout = null;
      onDoubleClick && onDoubleClick(e);
    } else {
      // 第一次点击，启动定时器进行单击延迟判断
      clickTimeout = setTimeout(() => {
        onSingleClick && onSingleClick(e);
        clickTimeout = null;
      }, singleClickDelay);
    }
  };

  return onClick;
};
